import { capitalizeFirstLetter } from "@dashboard/library";

import {
  BuildDataDogMessageArgs,
  FormatNumberWithThresholdOptions,
} from "./string.helpers.decl";

export function formatToPercentage(value: number) {
  return `${value}%`;
}

export function buildDataDogMessage({
  message,
  queryName,
}: BuildDataDogMessageArgs) {
  if (!queryName) {
    return `useQuery error: "${message}".`;
  }

  return `useQuery error: "${message}" on "${queryName}".`;
}

export function formatNumberWithThreshold(
  count: number,
  { threshold }: FormatNumberWithThresholdOptions
): string {
  if (count > threshold) {
    return `${threshold}+`;
  }

  return count.toString();
}

export function trimWithEllipsis(str: string, threshold: number) {
  if (str.length <= threshold) {
    return str;
  }

  return `${str.slice(0, threshold)}...`;
}

/**
 * Will capitalize a string
 * @param fullName - First and last name to capitalize
 * @returns - Capitalized string
 *
 * ## Example
 * ```typescript
 * capitalizeFullName('samwise gamgee') // => 'Samwise Gamgee'
 * capitalizeFullName('sam') // => 'Sam'
 * capitalizeFullName('gandalf the grey') // => 'Gandalf The Grey'
 * ```
 */
export function capitalizeString(fullName: string): string {
  const parts = fullName.split(/\s+/);
  return parts.map(capitalizeFirstLetter).join(" ");
}

export function removeDoubleQuotes(value: string) {
  return value.replaceAll(/"/g, "");
}

export function surroundWithQuotes(value: string) {
  return `"${value}"`;
}
